import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import WelcomePage from './screens/onboarding/welcomePage';
import ScanQRScreen from './screens/onboarding/scanqrScreen';
import OnboardScreen from './screens/onboarding/OnboardScreen';
import VerificationScreen from './screens/onboarding/verificationScreen.jsx';
import DPPScreen from './screens/product/DPPScreen';
import MapScreen from './screens/maps/MapScreen';
import CCMapScreen from './screens/maps/CCMapScreen';
import GS1DLScreen from './screens/product/GS1DLScreen';
import TemperatureGraph from './screens/product/TemperatureGraph';
// import { COMMON_PATH } from './utils/urlConfig';
import ProductResolver from './screens/product/ProductResolver';
import VerificationChecker from './screens/product/verification-checker';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<WelcomePage />} />

          {/* GS1 Digital Link resolver routes */}
          <Route path="/Product/01/:productId" element={<ProductResolver />} />
          <Route path="/Product/21/:sno" element={<ProductResolver />} />
          <Route path="/Product/01/:productId/10/:lot/21/:sno" element={<ProductResolver />} />
          <Route path="/Product/01/:productId/21/:sno" element={<ProductResolver />} />
          
          {/* GS1 Digital Link standard routes (Root Level) */}
          <Route path="/01/:productId" element={<ProductResolver />} />
          <Route path="/21/:sno" element={<ProductResolver />} />
          <Route path="/01/:productId/10/:lot/21/:sno" element={<ProductResolver />} />
          <Route path="/01/:productId/21/:sno" element={<ProductResolver />} />

          
          {/* Static routes */}
          <Route path="/onboard" element={<OnboardScreen />} />
          <Route path="/scanqr" element={<ScanQRScreen />} />
          <Route path="/01/:productId/21/:serialNumber/verification/:id" element={<VerificationScreen />} />
          <Route path="/01/:productId/21/:serialNumber/verification" element={<VerificationScreen />} />
          <Route path="/01/:productId/21/:serialNumber/dpp" element={<DPPScreen />} />
          <Route path="/01/:productId/21/:serialNumber/map" element={<MapScreen />} />
          <Route path="/01/:productId/21/:serialNumber/ccmap" element={<CCMapScreen />} />
          <Route path="/01/:productId/21/:serialNumber/gs1" element={<GS1DLScreen />} />
          <Route path="/01/:productId/21/:serialNumber/temperature-graph" element={<TemperatureGraph />} />
          <Route path="/verification-checker" element={<VerificationChecker />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
